import { render } from "./GlobalModalHost.vue?vue&type=template&id=4c125575"
import script from "./GlobalModalHost.vue?vue&type=script&lang=js"
export * from "./GlobalModalHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__